<template>
    <div class="patent_apply">
		<div class="patent_title">长三角地区商标数据(季度)</div>
		<div id="barChart7" style="width:100%;height:270px;"></div>
	</div>
</template>
<script>
    export default {
        data(){
            return{}
        },
		mounted() {},
        methods:{
			getData(list){
				this.drowChart7(list);
			},
            drowChart7(list) {
            	let myChart = this.$echarts.init(document.getElementById('barChart7'));
            	var option = {
            		tooltip: {
            			trigger: 'axis',
            			axisPointer: {
            				type: 'line',
            				lineStyle: {
            					color: 'red'
            				},
            			}
            		},
            		textStyle: {
            			color: '#fff',
            		},
            		grid: {
            			left: '0',
            			right: '0',
            			top: '30%',
            			bottom: '0',
            			containLabel: true
            		},
            		legend: {
            			icon: 'diamond',
            			itemWidth: 10,
            			itemHeight: 10,
						top:'5%',
            			itemGap: 24, // 设置间距
            			left: 'center',
            			data: ['申请量', '注册量','有效注册量'],
            			textStyle: {
            				color: '#fff',
            			},
            		},
            		xAxis: [{
            			type: 'category',
            			data:list.map(item =>item.name),
            			axisTick: {
            				alignWithLabel: true
            			},
            			axisLabel: {
            				interval: 0, //数据过多时不间隔显示名称
            			},
            			axisLine: { //X轴坐标线隐藏
            				show: false,
            			},
            		}],
            		yAxis: [{
            			show: false, //Y轴坐标线隐藏
            			type: 'value',
            			axisLabel : {   //Y轴隐藏过后产生留白
            				formatter: function(){
            					return "";
            				}
            			}
            		}],
            		series: [
            			{
            				name: '申请量',
            				type: 'bar',
            				barWidth: '20%',
            				barGap: '10%',
            				label: {
            					show: true,
            					position: 'outside',
            					color: '#fff'
            				},
            				color: '#459CD0',
            				data:list.tmsqList.map(item =>item.value)
            			},{
            				name: '注册量',
            				type: 'bar',
            				barWidth: '20%',
            				barGap: '10%',
            				label: {
            					show: true,
            					position: 'outside',
            					color: '#fff'
            				},
            				color: '#83C13E',
            				data:list.sqtmList.map(item =>item.value)
            			},{
            				name: '有效注册量',
            				type: 'bar',
            				barWidth: '20%',
            				barGap: '10%',
            				label: {
            					show: true,
            					position: 'outside',
            					color: '#fff'
            				},
							color: '#01BEF4',
            				data:list.yxzctmList.map(item =>item.value)
            			}
            		],
            	};
            	myChart.setOption(option);
            	window.addEventListener("resize", function() {
            		myChart.resize();
            	});
            },
        }
    }
</script>